// This file configures the initialization of Sentry and PostHog on the client.
// The added config here will be used whenever a user loads a page in their browser.
// Sentry docs: https://docs.sentry.io/platforms/javascript/guides/nextjs/
// PostHog docs: https://posthog.com/docs

import * as Sentry from "@sentry/nextjs"
import { env } from "./env/client"
import posthog from "posthog-js"

const mode =
  process.env.VERCEL_ENV ??
  process.env.NEXT_PUBLIC_VERCEL_ENV ??
  process.env.NODE_ENV
const enabled = mode?.includes("production") || mode?.includes("preview")

Sentry.init({
  dsn: "https://f14268791d92f9b4183015b90d3d5a38@o465878.ingest.us.sentry.io/4506280286617600",

  // Enable logs to be sent to Sentry
  _experiments: { enableLogs: true },

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  integrations: [
    // send console.log, console.error, and console.warn calls as logs to Sentry
    Sentry.consoleLoggingIntegration(),
  ],

  enabled,
})

if (enabled) {
  // Initialize PostHog
  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    capture_pageview: "history_change",
    capture_pageleave: true, // Enable pageleave capture
    capture_exceptions: true, // Enable exception capture (Error Tracking)
    debug: process.env.NODE_ENV === "development",
  })
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
